import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ErrorBoundary } from "./app/ErrorBoundary.js";
import "./app/i18n.js";
import { router } from "./app/router.js";
import { SessionProvider } from "./app/session.js";
import { queryClient } from "./app/trpc.js";
import { UpdateBanner } from "./app/UpdateBanner.js";
import { installUpdateHandlers } from "./app/update.js";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

// Service worker регистрируем сами (не автовставкой плагина), чтобы подхватить новую версию без потери ввода (app/update.ts).
// За переходами следит корневой маршрут (app/Root.tsx).
installUpdateHandlers();

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <RouterProvider router={router} />
          <UpdateBanner />
        </SessionProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
